import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-video.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSBasicVideo = props => {
  const {
    analytics,
    autoplay,
    className,
    crossOrigin,
    muted,
    pauseOnOtherPlay = true,
    playsInline = true,
    poster,
    preload,
    src,
    tracks,
    videoRef
  } = props;
  const wrapperVideoClassNames = getClassNameList('uitk-video-basic', className);
  const onPlay = e => {
    // When starting to play one video, pause all others
    const videoElements = document.querySelectorAll('video.pause-on-other-play');
    for (const video of videoElements) {
      if (video !== e.target) {
        video.pause();
      }
    }
    analyticsTracker(analytics, 'playVideo', '');
  };
  /* eslint-disable jsx-a11y/media-has-caption */
  return jsx("div", {
    className: wrapperVideoClassNames,
    children: jsx("video", {
      onPlay: onPlay,
      onPause: () => analyticsTracker(analytics, 'pauseVideo', ''),
      ...(autoplay && {
        autoPlay: true
      }),
      controls: true,
      crossOrigin: crossOrigin,
      muted: muted,
      playsInline: playsInline,
      poster: poster,
      preload: preload,
      ref: videoRef,
      src: src,
      className: pauseOnOtherPlay ? 'pause-on-other-play' : '',
      children: tracks &&
      // Default caption type to 'captions' if kind is not predefined.
      tracks.map((trackProps, i) => jsx("track", {
        kind: "captions",
        ...trackProps
      }, i))
    })
  });
};
export { EGDSBasicVideo };